export default "__VITE_ASSET__m_tO1HxV__"